export const layers_dictionary = {
  zoom9_population: 'population',
  flood_ind: 'floods',
  mudflow_ind: 'debris_flow',
  NDVI: 'vegetation_index 10⁻¹',
  'LST-DIF': 'lst_dif',
  LST: 'lst',
  pm25: 'PM2.5',
  'AIR-CO': 'CO 10⁻²',
  'AIR-HCHO': 'HCHO 10⁻⁵',
  'AIR-NO2': 'NO2 10⁻⁶',
  'AIR-SO2': 'SO2 10⁻⁴',
};
